import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "@reach/router"; // this helps tracking the location
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies";
import styled from "styled-components";
import Cookies from "universal-cookie";
import Header from "../components/header";
import Footer from "../components/footer";
import NewsletterSignUp from "./Layout/newsletterSignUp";
import NewsletterFooter from "./newsletterFooter";
import CookieConsent from "./Layout/cookieConsent";

const cookies = new Cookies();

const MainLayout = styled.div`
  ${(props) =>
    props.bannerVisible ? "padding-top: 150px;" : " padding-top: 130px;"}
  max-height: 100%;
  @media (max-width: 726px) {
    ${(props) =>
      props.newletterSignUpSeen ? "height: 100%;" : "height: 100vh;"}
    ${(props) =>
      props.newletterSignUpSeen ? "overflow-y: scroll;" : "overflow-y: hidden;"}
  }
`;

const Layout = ({
  children,
  bannerVisible,
  hideNewsletterFooter,
  noNavigation = false,
  trial = false,
}) => {
  const [newletterSignUpSeen, setNewletterSignUpSeen] = useState(true);
  const [melTrialVisible, setMelTrialVisible] = useState(false);
  const [showCookieConsent, setShowCookieConsent] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("newletterSignUpSeen")) {
      setNewletterSignUpSeen(true);
    } else {
      if (sessionStorage.getItem("showingSignUp")) {
        setNewletterSignUpSeen(false);
      } else {
        setTimeout(() => {
          setNewletterSignUpSeen(false);
          sessionStorage.setItem("showingSignUp", true);
        }, 15000);
      }
    }
    if (!cookies.get("cookieBannerSeen")) {
      setShowCookieConsent(true);
    }
  }, []);

  const onCloseNewsletterSignUp = () => {
    localStorage.setItem("newletterSignUpSeen", "true");
    sessionStorage.setItem("showingSignUp", false);
    setNewletterSignUpSeen(true);
  };

  const closeMelTrial = () => {
    setMelTrialVisible(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (noNavigation) {
      setTimeout(() => {
        setMelTrialVisible(true);
      }, 20000);
    }
  }, [noNavigation]);

  const handleCookieConsent = (consentGiven) => {
    const cookieSettings = {
      maxAge: 31536000, // 1 year
      path: "/",
      sameSite: "none",
      secure: true,
    };
    if (consentGiven) {
      cookies.set("gatsby-gdpr-google-analytics", true, cookieSettings);
      cookies.set("gatsby-gdpr-facebook-pixel", true, cookieSettings);
      cookies.set("gatsby-gdpr-hotjar", true, cookieSettings);
      cookies.set("cookieBannerSeen", true, cookieSettings);
      initializeAndTrack(window.location);
    }
    cookies.set("cookieBannerSeen", true, cookieSettings);
    setShowCookieConsent(false);
  };

  return (
    <MainLayout
      bannerVisible={bannerVisible}
      newletterSignUpSeen={
        newletterSignUpSeen || (noNavigation && !melTrialVisible)
      }
    >
      <Helmet defer={false}>
        <html lang="en" ontouchmove />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <script>{`
          function initApollo(){var n=Math.random().toString(36).substring(7),o=document.createElement("script");
          o.src="https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache="+n,o.async=!0,o.defer=!0,
          o.onload=function(){window.trackingFunctions.onLoad({appId:"663af847e5fb31030379cf7b"})},
          document.head.appendChild(o)}initApollo();
        `}</script>
      </Helmet>
      <Header
        bannerVisible={bannerVisible}
        noNavigation={noNavigation}
        trial={trial}
      />
      {children}
      {melTrialVisible && noNavigation && !trial ? (
        <NewsletterSignUp onClose={closeMelTrial} noNavigation={noNavigation} />
      ) : null}
      {!newletterSignUpSeen && !noNavigation && !trial ? (
        <NewsletterSignUp
          onClose={onCloseNewsletterSignUp}
          noNavigation={noNavigation}
        />
      ) : null}
      {showCookieConsent ? (
        <CookieConsent handleCookieConsent={handleCookieConsent} />
      ) : null}
      {!hideNewsletterFooter && <NewsletterFooter />}
      <Footer noNavigation={noNavigation} />
    </MainLayout>
  );
};

export default Layout;
